var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"create-loading",staticStyle:{"padding-top":"var(--progress-padding-top, 0)"}},[_c('ProgressView',{attrs:{"value":_vm.progressVal}}),_c('div',{staticClass:"tips"},[_vm._v("请遵守《生成式人工智能服务管理办法》")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }